<template>
   <span :class="statusObj.class"><span v-if="nearingCapacity">{{ inventory }}</span> {{ $t(statusObj.label) }}</span>
</template>

<script type="text/javascript">
import constants from '@/include/constants';
   export default {
      props: [
         'status',
         'inventory'
      ],

      data() {
         return {
            constants
         }
      },

      computed: {
         statusObj(){
            var temp = {};
            switch (this.status){
               case this.constants.INVENTORY_STATUS_AVAILABLE:
                  temp.label = "general.label.available";
                  temp.class = "available";
                  break;
               case this.constants.INVENTORY_STATUS_NEARING_CAPACITY:
                  temp.label = "availability.left";
                  temp.class = "nearing-capacity"; 
                  break;
               case this.constants.INVENTORY_STATUS_UNAVAILABLE:
                  temp.label = "general.label.unavailable";
                  temp.class = "unavailable";
                  break;
               case this.constants.INVENTORY_STATUS_SOLDOUT:
                  temp.label = "general.label.sold-out";
                  temp.class = "sold-out";
                  break;
               default:
                  break;
            }
            return temp;
         },
         nearingCapacity(){
            return this.status == this.constants.INVENTORY_STATUS_NEARING_CAPACITY;
         }
      }
   };
</script>

<style lang="scss">
.nearing-capacity {
   @include badge($colorYellow);
 }

 .sold-out,.unavailable {
   @include badge($colorGray);
 }

 .available {
   @include badge($colorBlue);
 }
</style>